<div class="chart-holder" style="background: #161616;">
  <div #myCharts echarts [options]="option" class="demo-chart" (chartInit)="onChartInit($event)"></div>
  <div *ngIf="noData" class="no-data">
    <div>
      You can generate this chart by uploading properties.
      <button mat-button (click)="goToProject()">Upload Property</button>
    </div>
    <img src="./assets/images/property-demo.png">
  </div>
</div>